<!-- 
Panel for changing a password.
-->
<template>
  <v-form ref="form">
    <v-card>
      <v-toolbar v-if="dialog" color="secondary" flat dark>
        <v-toolbar-title>Change password</v-toolbar-title>
        <v-spacer/>
        <our-user-guide-button topic="common" section="accessing-the-system"/>
      </v-toolbar>
      <our-busy-indicator :show="state.busy" />
      <v-card-text>
        <v-container :class="containerCss">
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field 
                v-model="user.currentPassword"
                :append-icon="showPassword1 ? 'visibility_off' : 'visibility'"
                :rules="[rules.required]" :type="showPassword1 ? 'text' : 'password'"
                name="input-10-1" label="Current password" autocomplete="off" autofocus
                required @click:append="showPassword1 = !showPassword1"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field 
                v-model="user.newPassword"
                :append-icon="showPassword2 ? 'visibility_off' : 'visibility'"
                :rules="[rules.required, min14]" :type="showPassword2 ? 'text' : 'password'"
                name="input-10-1" label="New password" autocomplete="off"
                required @click:append="showPassword2 = !showPassword2" @input="newPasswordChanged"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field 
                v-model="user.newPasswordConfirmation"
                :append-icon="showPassword3 ? 'visibility_off' : 'visibility'"
                :rules="[rules.required, matchesPassword]" :type="showPassword3 ? 'text' : 'password'"
                name="input-10-1" label="New password again (to confirm)" autocomplete="off"
                required @click:append="showPassword3 = !showPassword3"
              />
            </v-flex>
          </v-layout>
        </v-container>
        <our-validation-dialog v-model="showValidationDialog" :form="this.$refs.form" :state-error="state.error" show-security-errors />
      </v-card-text>
      <v-card-actions>
        <template v-if="dialog">
          <our-user-guide-button topic="common" section="changing-password"/>
          <v-spacer/>
          <v-btn :disabled="state.busy" flat @click.native="$emit('changed')">Cancel</v-btn>
          <v-btn 
            :disabled="state.busy" flat color="primary" 
            type="submit" @click.prevent="submit"
          >Change password</v-btn>
        </template>
        <template v-else>
          <v-flex shrink class="ml-3 mb-3">
            <our-user-guide-button topic="common" section="changing-password"/>
          </v-flex>
          <v-flex grow class="text-sm-right mb-3">
            <v-btn :disabled="state.busy" to="/sign-out">Cancel</v-btn>
            <v-btn 
              :disabled="state.busy" type="submit" 
              class="mr-2" color="primary" @click.prevent="submit"
            >
              Change password
            </v-btn>
          </v-flex>
        </template>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import * as action from "@/store/users/action-types";
import ruleMixins from "@/mixins/rule.mixins";

export default {
  mixins: [ruleMixins],
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showValidationDialog: false,
      showPassword1: false,
      showPassword2: false,
      showPassword3: false,
      user: {
        currentPassword: "",
        newPassword: "",
        newPasswordConfirmation: "",
        cookie: true
      }
    };
  },
  computed: {
    state() {
      return this.$store.state.users.user;
    },
    containerCss() {
      return this.dialog ? "grid-list-md pa-0" : "grid-list-xl pa-3";
    },
    min14() {
      return pwd => (pwd && pwd.length < 14 ? "Password must have at least 14 characters" : true);
    },
    matchesPassword() {
      return () => {
        const bothCompleted = this.user.newPassword && this.user.newPasswordConfirmation;
        if (bothCompleted && this.user.newPasswordConfirmation != this.user.newPassword) {
          return "Your two new password values do not match";
        } else {
          return true;
        }
      };
    }
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate() && (await this.$store.dispatch(action.CHANGE_PASSWORD, this.user))) {
        this.$emit("changed");
      } else {
        this.showValidationDialog = true;
      }
    },
    newPasswordChanged() {
      this.user.newPasswordConfirmation = "";
    },
    clear() {
      this.user.currentPassword = "";
      this.user.newPassword = "";
      this.user.newPasswordConfirmation = "";
      this.$refs.form.reset();
    }
  }
};
</script>
